var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 5.00004V3.33337M9.99998 5.00004C9.0795 5.00004 8.33331 5.74623 8.33331 6.66671C8.33331 7.58718 9.0795 8.33337 9.99998 8.33337M9.99998 5.00004C10.9205 5.00004 11.6666 5.74623 11.6666 6.66671C11.6666 7.58718 10.9205 8.33337 9.99998 8.33337M4.99998 15C5.92045 15 6.66665 14.2538 6.66665 13.3334C6.66665 12.4129 5.92045 11.6667 4.99998 11.6667M4.99998 15C4.07951 15 3.33331 14.2538 3.33331 13.3334C3.33331 12.4129 4.07951 11.6667 4.99998 11.6667M4.99998 15V16.6667M4.99998 11.6667V3.33337M9.99998 8.33337V16.6667M15 15C15.9205 15 16.6666 14.2538 16.6666 13.3334C16.6666 12.4129 15.9205 11.6667 15 11.6667M15 15C14.0795 15 13.3333 14.2538 13.3333 13.3334C13.3333 12.4129 14.0795 11.6667 15 11.6667M15 15V16.6667M15 11.6667V3.33337",
    stroke: "#4F46E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.f1a127fa3749d1d41f10aa23c9d35012.svg";
export { ForwardRef as ReactComponent };